import { render, staticRenderFns } from "./UserPaymentsMethodsCard.vue?vue&type=template&id=71498059&"
import script from "./UserPaymentsMethodsCard.vue?vue&type=script&lang=js&"
export * from "./UserPaymentsMethodsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports